import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="App-footer">
        <p className="made">Made With ❤ by Leonel Oliveira</p>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js